import { render } from "./Back.vue?vue&type=template&id=87d9e812"
import script from "./Back.vue?vue&type=script&lang=js"
export * from "./Back.vue?vue&type=script&lang=js"

import exportComponent from "/home/circleci/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__